import type {
  ParsedAnalyticsSchema,
  ParsedAnalyticsSchemaKey,
} from '../types/AnalyticsSchema';

export function filterData({
  data,
  filters,
  searchValue,
}: {
  data: ParsedAnalyticsSchema[];
  filters: Record<string, string>;
  searchValue: string;
}) {
  return data.filter((row) =>
    Object.keys({ ...filters, s: searchValue }).every((filterKey: string) => {
      if (typeof filterKey !== 'string') {
        return false;
      }

      // Cast filterKey to ParsedAnalyticsSchemaKey
      const key = filterKey as ParsedAnalyticsSchemaKey;

      // result if the filter is empty or the row matches the filter
      const rowValue = key === 'domain' ? row.metadata[key] : row[key];
      const matchesFilter =
        filters[filterKey] === '' || rowValue === filters[filterKey];

      // result if the search query is empty or the row matches the search query
      const matchesSearch =
        searchValue === '' ||
        Object.values(row).some((value) => {
          if (typeof value !== 'string') {
            return false;
          }

          return value.toLowerCase().includes(searchValue.toLowerCase());
        });

      // based on the two results above, return the row if it matches both the filter and the search query
      // either the filter or the search query can be empty, but if both are empty, the row will always be returned

      return matchesSearch && matchesFilter;
    }),
  );
}
